<agr-form-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (alt)="alt()"
  (cancel)="cancel()"
  [data]="data"
>
  <div class="flex--column">
    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'create-product.product-name' | translate }}</mat-label>
      <input
        matInput
        formControlName="productName"
        placeholder="{{ 'create-product.product-name' | translate }}"
        data-test="create-product__product-name"
      />
      <mat-error *ngIf="formGroup.controls.productName.errors?.required">
        {{ 'create-product.error-product-name' | translate }}</mat-error
      >

      <mat-error *ngIf="formGroup.controls.productName.errors?.productCodeNameAlreadyInUse">
        {{ 'create-product.error-code-name-already-in-use' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-form-field class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'create-product.product-code' | translate }}</mat-label>
      <input
        matInput
        formControlName="productCode"
        placeholder="{{ 'create-product.product-code' | translate }}"
        data-test="create-product__product-code"
      />
      <mat-error *ngIf="formGroup.controls.productCode.errors?.required">
        {{ 'create-product.error-product-code' | translate }}</mat-error
      >

      <mat-error *ngIf="formGroup.controls.productCode.errors?.productCodeNameAlreadyInUse">
        {{ 'create-product.error-code-name-already-in-use' | translate }}</mat-error
      >
    </mat-form-field>

    <mat-radio-group formControlName="type" class="flex__child--auto spacing--margin-top">
      <mat-label>{{ 'create-product.product-type.label' | translate }}</mat-label>
      <mat-radio-button
        data-test="create-product__product-type-feed"
        class="text--small"
        color="primary"
        [value]="'Feed'"
      >
        {{ 'create-product.product-type.Feed' | translate }}
      </mat-radio-button>
      <mat-radio-button
        data-test="create-product__product-type-additive"
        class="text--small"
        color="primary"
        [value]="'Additive'"
      >
        {{ 'create-product.product-type.Additive' | translate }}
      </mat-radio-button>
    </mat-radio-group>
    <mat-error *ngIf="formGroup.controls.type.errors?.required">
      {{ 'create-product.error-product-type' | translate }}</mat-error
    >
  </div>
</agr-form-dialog>
